import { defineMessages } from 'react-intl';

export const searchMessages = defineMessages({
  article: {
    defaultMessage: 'Vision',
    description: 'Chip label for article type in search results',
    id: 'search.chip.article',
  },
  empty: {
    defaultMessage: 'Sorry, we couldn\'t find what you\'re looking for',
    description: 'Empty results information',
    id: 'search.text.empty',
  },
  fieldMessageToShort: {
    defaultMessage: 'Search phrase should be at least 3 characters long',
    description: 'Validation message for search field',
    id: 'search.validationMessage',
  },
  headingSearch: {
    defaultMessage: 'Looking For Something?',
    description: 'Heading for the Search page',
    id: 'search.heading',
  },
  media: {
    defaultMessage: 'Media',
    description: 'Chip label for media (in the news) type in search results',
    id: 'search.chip.media',
  },
  moment: {
    defaultMessage: 'Moment',
    description: 'Chip label for moment type in search results',
    id: 'search.chip.moment',
  },
  placeholder: {
    defaultMessage: 'Search',
    description: 'Subject text field label',
    id: 'search.input.placeholder',
  },
  results: {
    defaultMessage: 'Results ({total})',
    description: 'results list title',
    id: 'search.text.results',
  },
  subheadingSearch: {
    defaultMessage: 'Search for Her Excellency\'s articles, media news, moments etc.',
    description: 'Subeading for the Search page',
    id: 'search.subheading',
  },
} as const);
